import { traverseDescription } from "./traverse-description.js";
import { traversePaths } from "./traverse-paths.js";
import { traverseSchemas } from "./traverse-schemas.js";
import { traverseTags } from "./traverse-tags.js";
import { traverseWebhooks } from "./traverse-webhooks.js";
const traverseDocument = (document, {
  hideModels = false,
  tagsSorter = "alpha",
  operationsSorter = "alpha",
  getHeadingId = (heading) => heading.value,
  getOperationId = (operation) => operation.summary ?? "",
  getWebhookId = (webhook) => webhook?.name ?? "webhooks",
  getModelId = (model) => model?.name ?? "",
  getTagId = (tag) => tag.name ?? ""
}) => {
  const titles = /* @__PURE__ */ new Map();
  const tagsMap = new Map(
    document.tags?.map((tag) => [tag.name ?? "Untitled Tag", { tag, entries: [] }]) ?? []
  );
  const entries = traverseDescription(document.info?.description, titles, getHeadingId);
  traversePaths(document, tagsMap, titles, getOperationId);
  const untaggedWebhooks = traverseWebhooks(document, tagsMap, titles, getWebhookId);
  const tagsEntries = traverseTags(document, tagsMap, titles, {
    getTagId,
    tagsSorter,
    operationsSorter
  });
  entries.push(...tagsEntries);
  if (untaggedWebhooks.length) {
    entries.push({
      id: getWebhookId({ name: "" }),
      title: "Webhooks",
      children: untaggedWebhooks,
      type: "text"
    });
  }
  if (!hideModels && document.components?.schemas) {
    const untaggedModels = traverseSchemas(document, tagsMap, titles, getModelId);
    if (untaggedModels.length) {
      entries.push({
        id: getModelId({}),
        title: "Models",
        children: untaggedModels,
        type: "text"
      });
    }
  }
  return { entries, titles };
};
export {
  traverseDocument
};
//# sourceMappingURL=traverse-document.js.map
